import type { HTMLAttributes } from "react";

export type TextElementProps = HTMLAttributes<HTMLDivElement>

export const Title = ({ children, ...props}: TextElementProps) => {
  return (
    <h3
      dir="auto"
      className="inline-flex w-full items-center justify-start text-xl font-bold truncate"
      {...props}
    >
      {children}
    </h3>
  );
};

export const Badge = ({children, ...props}: TextElementProps) => {
  return (
    <span className="mx-2 rounded-xl bg-purple-400/10 px-2 py-1 text-sm font-normal text-purple-600" {...props}>
      {children}
    </span>
  );
};

export const Paragraph = ({ children, ...props }: TextElementProps) => {
  return (
    <div className="group relative">
      <p
        className="my-2 text-gray-400 line-clamp-3"
        {...props}
      >
        {children}
      </p>
      <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden w-max max-w-xs rounded bg-gray-800 px-2 py-1 text-sm text-white group-hover:block whitespace-normal" dir="ltr">
        {children}
      </div>
    </div>
  );
};